import React from 'react';
import { Link } from 'react-router-dom';
import SubLayout from '../../../components/Layout/SubLayout.js';
import strings from "../../../components/Language/index.js";
import Switch from '@mui/material/Switch';
import ArrowForWord from './../../../assets/images/icons/arrow_forword.svg';
import "./../tradebot.scss";
import { Form, Input, Button } from 'antd';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../../components/config/api.js';
import { getToken, storeUserData } from '../../../components/Util/index.js';
import _ from 'lodash';
import LoaderContext from '../../../components/Loader/LoaderContext.js';
import { str } from 'ajv';

class SettingScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        var params_id = this.props.match.params.id;
        this.state = {
            lang: strings.getLanguage(),
            loading: false,
            params_id: params_id,
            access_token: "",
            data: [],
            is_load: false,
            time_frame: 0,
            line: 0,
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'GET',
                url: api.botc + this.state.params_id + "/detail",
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {

                    self.setState({
                        data: ress.data.data,
                        line: (ress.data.data && ress.data.data.line) ? ress.data.data.line : 0,
                        time_frame: (ress.data.data && ress.data.data.time_frame) ? ress.data.data.time_frame : 0,
                        is_load: true,
                    });
                } else {
                    self.setState({
                        is_load: true,
                    });
                    if (ress.data.validation && ress.data.validation.length !== 0) {

                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                setTimeout(() => {
                    setLoading(false);
                });
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    onFinish(values) {
        const { setLoading } = this.context;
        setLoading(true);

        values.time_frame = this.state.time_frame;
        values.line = this.state.line;
        var self = this;
        self.setState({ loading: true });
        axios({
            method: 'POST',
            url: api.botc + this.state.params_id + "/trade-settings",
            data: values,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage(),
            }
        }).then(function (ress) {
            setLoading(false);
            if (ress.data && ress.data.error === 200) {
                toast.success(ress.data.message);
                self.getData();
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {
                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
            }
            self.setState({ loading: false });
        }).catch(function (e) {
            setLoading(false);
            self.setState({ loading: false });
        });
    };

    render() {
        return (
            <SubLayout data={{ "title": strings.trade_settings }}>
                {this.state.is_load ?
                    <Form
                        className='offset-md-4 col-md-4 trad_bot'
                        name="sign-in"
                        onFinish={(data) => this.onFinish(data)}
                        initialValues={{
                            first_buy_amount: (this.state.data && this.state.data.first_buy_amount) ? this.state.data.first_buy_amount : 0,
                            margin_call_limit: (this.state.data && this.state.data.margin_call_limit) ? this.state.data.margin_call_limit : 0,
                            take_profit_ratio: (this.state.data && this.state.data.take_profit_ratio) ? this.state.data.take_profit_ratio : 0,
                            take_profit_callback: (this.state.data && this.state.data.take_profit_callback) ? this.state.data.take_profit_callback : 0,
                            buy_in_call_back: (this.state.data && this.state.data.buy_in_call_back) ? this.state.data.buy_in_call_back : 0,
                            line: (this.state.data && this.state.data.line) ? this.state.data.line : 0,
                            time_frame: (this.state.data && this.state.data.time_frame) ? this.state.data.time_frame : 0,
                        }}
                    >
                        <div className="list_item" style={{ padding: 0, paddingBlock: 10 }}>
                            <div className='row' style={{ margin: 10, marginTop: 20 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.first_buy_in_amount}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Form.Item
                                        name="first_buy_amount"
                                    >
                                        <Input className="form-control rounded-xs" />
                                    </Form.Item>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14, marginLeft: 5 }}> {strings.usdt}</label>
                                </div>
                            </div>
                        </div>
                        <div className="list_item" style={{ padding: 0, paddingBlock: 10 }}>
                            <div className='row' style={{ margin: 10, marginTop: 20 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.margin_call_limit}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Form.Item
                                        name="margin_call_limit"
                                    >
                                        <Input className="form-control rounded-xs" />
                                    </Form.Item>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14, marginLeft: 18 }}></label>
                                </div>
                            </div>
                            <div className='boder_' />
                            <div className='row' style={{ margin: 10 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.take_profit_ratio}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Form.Item
                                        name="take_profit_ratio"
                                    >
                                        <Input className="form-control rounded-xs" />
                                    </Form.Item>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14, marginLeft: 5 }}> %</label>
                                </div>
                            </div>
                            <div className='boder_' />
                            <div className='row' style={{ margin: 10 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.take_profit_call_back}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Form.Item
                                        name="take_profit_callback"
                                    >
                                        <Input className="form-control rounded-xs" />
                                    </Form.Item>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14, marginLeft: 5 }}> %</label>
                                </div>
                            </div>
                            <div className='boder_' />
                            <div className='row' style={{ margin: 10 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.buy_in_callback}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Form.Item
                                        name="buy_in_call_back"
                                    >
                                        <Input className="form-control rounded-xs" />
                                    </Form.Item>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14, marginLeft: 5 }}> %</label>
                                </div>
                            </div>
                        </div>
                        <div className="list_item" style={{ padding: 0, paddingBlock: 10 }}>
                            <div className='row' style={{ margin: 10, marginTop: 20 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.line}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Select
                                        value={this.state.line}
                                        name="line"
                                        style={{ backgroundColor: "transparent", color: "#FFFFFF", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                        label={strings.line}
                                        onChange={(e) => this.setState({ line: e.target.value })}
                                    >
                                        <MenuItem value={0}>{strings.Stratergy_1}</MenuItem>
                                        <MenuItem value={1}>{strings.Stratergy_2}</MenuItem>
                                        <MenuItem value={2}>{strings.Stratergy_3}</MenuItem>
                                    </Select>
                                </div>
                            </div>
                            <div className='boder_' />
                            <div className='row' style={{ margin: 10, marginTop: 20 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.Time_Frame}</label>
                                </div>
                                <div className='col-4 main_content'>
                                    <Select
                                        value={this.state.time_frame}
                                        name="time_frame"
                                        style={{ backgroundColor: "transparent", color: "#FFFFFF", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                        label={strings.Time_Frame}
                                        onChange={(e) => this.setState({ time_frame: e.target.value })}
                                    >
                                        <MenuItem value={0}>{"5 " + strings.Minute}</MenuItem>
                                        <MenuItem value={1}>{"15" + strings.Minute}</MenuItem>
                                        <MenuItem value={2}>{"30 " + strings.Minute}</MenuItem>
                                        <MenuItem value={3}>{"1 " + strings.Hour}</MenuItem>
                                        <MenuItem value={4}>{"4 " + strings.Hour}</MenuItem>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="list_item" style={{ padding: 0, paddingBlock: 10 }}>
                            <Link to={{ pathname: `/ai-bot-margin-configuration/${this.state.params_id}` }} className='row' style={{ margin: 10 }}>
                                <div className='col-8' style={{ marginTop: 0 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.margin_configuration}</label>
                                </div>
                                <div className='col-4' style={{ marginTop: 0, textAlign: "right" }}>
                                    <img src={ArrowForWord} alt="" style={{ marginLeft: 20 }} />
                                </div>
                            </Link>
                        </div>

                        <div style={{ padding: 0, margin: 10 }}>
                            <Form.Item>
                                <Button
                                    loading={this.state.loading}
                                    htmlType="submit"
                                    className='btn rounded-sm btn-m login_button text-uppercase font-700 mt-4 mb-3 btn-full '
                                    style={{ opacity: this.state.loading ? 0.7 : 1, fontSize: 14, paddingBlock: 10, background: '#5CBC7C', color: "#FFF", width: "100%", borderRadius: 10 }}
                                >
                                    {this.state.loading ? strings.loading : strings.save}
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                    : null}
            </SubLayout >
        );
    }
}

export default SettingScreen;